import { devfolioFetch } from "./devfolioApi";

/**
 * Fetches unique departments from BigQuery (directory_employees).
 * @returns {Promise<{ok: boolean, departments: string[]}>}
 */
export async function getDepartments() {
  try {
    const data = await devfolioFetch("departments");
    return {
      ok: data.ok === true,
      departments: Array.isArray(data.departments) ? data.departments : [],
    };
  } catch (err) {
    console.error("Error fetching departments:", err);
    return { ok: false, departments: [] };
  }
}
